import { formatRoute } from '@/helpers/formatRoute'
import { transparentPagesNames } from '~/utils/headerTheme'
import type { RouteLocation } from 'vue-router'

type PageTheme = 'white' | 'transparent' | ''

type HeaderNavigation = {
  customPageTheme: PageTheme
  nextRoute: RouteLocation | null
  routeName: string
  temporaryTheme: PageTheme
  urlFrom: string
}

export const useHeaderNavigation = () => {
  const headerNavigation = useState<HeaderNavigation>(
    'header-navigation',
    () => ({
      customPageTheme: '', // if one route can have several themes
      nextRoute: null,
      routeName: '',
      temporaryTheme: '',
      urlFrom: '',
    }),
  )

  const headerHeight = computed(() => 74)

  const pageTheme = computed(() => {
    if (headerNavigation.value.customPageTheme) {
      return headerNavigation.value.customPageTheme
    }

    if (transparentPagesNames.includes(headerNavigation.value.routeName)) {
      return 'transparent'
    }

    return 'white'
  })

  const headerTheme = computed(() => {
    if (headerNavigation.value.temporaryTheme) {
      return headerNavigation.value.temporaryTheme
    }

    return pageTheme.value
  })

  const setCustomPageTheme = (theme: PageTheme) => {
    headerNavigation.value.customPageTheme = theme
  }

  const setRoute = (localeRoute: string) => {
    const globalRoute = formatRoute(localeRoute)

    headerNavigation.value.routeName = globalRoute
  }

  const setNextRoute = (route: RouteLocation | null) => {
    headerNavigation.value.nextRoute = route
  }

  const setTemporaryTheme = (theme: PageTheme) => {
    headerNavigation.value.temporaryTheme = theme
  }

  const setUrlFrom = (url: string) => {
    headerNavigation.value.urlFrom = url
  }

  return {
    headerHeight,
    headerNavigation,
    headerTheme,
    pageTheme,
    setCustomPageTheme,
    setNextRoute,
    setRoute,
    setTemporaryTheme,
    setUrlFrom,
  }
}
